import React from 'react';
import Chat from './Chat';
import './Chat.css';
import './ChatPage.css';

const ChatPage: React.FC = () => {
  return (
    <div className="chat-page">
      <Chat alwaysOpen={true} />
    </div>
  );
};

export default ChatPage;